export const PRECHECK_OPTIONS = [
  {
    value: "holdings",
    dataAid: "holdings",
    title: "Holdings",
    status: "success",
  },
  {
    value: "positions",
    dataAid: "openPosition",
    title: "Open positions",
    status: "success",
  },
  {
    value: "ledger_balance",
    dataAid: "ledgerBalance",
    title: "Ledger balance",
    status: "success",
  },
  {
    value: "dp_pending_bills",
    dataAid: "pendingDematBills",
    title: "Pending Demat bills",
    status: "success",
  },
];

export const OTHER_PRECHECK_OPTIONS = [
  {
    value: "open_tpp",
    dataAid: "primaryMarket",
    title: "Primary market orders",
    status: "pending",
    sheetTitle: "Primary market orders",
    sheetSubtitle:
      "We will check if you have any primary market orders & notify you",
  },
  {
    value: "unbilled_demat",
    dataAid: "unbilledDemat",
    title: "Unbilled Demat transactions",
    status: "pending",
    sheetTitle: "Unbilled Demat transactions",
    sheetSubtitle:
      "We will check if you have unbilled transactions & notify you",
  },
];

export const OTHER_PRECHECK_OPTIONS_REJECTED = [
  {
    value: "open_tpp",
    dataAid: "primaryMarket",
    title: "Primary market orders",
    status: "failed",
    sheetTitle: "Primary market orders pending",
    sheetSubtitle:
      "You have open primary market orders (IPO/SGB/NCD...). Close open orders to proceed",
  },
  {
    value: "unbilled_demat",
    dataAid: "unbilledDemat",
    title: "Unbilled Demat transactions",
    status: "failed",
    sheetTitle: "Unbilled Demat transactions",
    sheetSubtitle:
      "You have demat transactions that are yet to be billed. Please wait for the bill to be generated before closing account",
  },
];

export const CLOSURE_REASON_LIST = [
  {
    title: "Not using my account ",
    value: 0,
    isRequired: false,
    dataAid: "notUsing",
  },
  {
    title: "App is complicated",
    value: 1,
    isRequired: false,
    dataAid: "appComplicated",
  },
  {
    title: "Facing payment issues",
    value: 2,
    isRequired: false,
    dataAid: "facingPayment",
  },
  {
    title: "Not getting customer support",
    value: 3,
    isRequired: false,
    dataAid: "customerSupport",
  },
  {
    title: "App keeps crashing",
    value: 4,
    isRequired: false,
    dataAid: "appCrashes",
  },
  {
    title: "Others",
    value: 5,
    isRequired: true,
    dataAid: "others",
  },
];

export const MANUAL_SIGNATURE_STEPS = [
  {
    title: "Get all the forms",
    subtitle: "Forms with instructions will be emailed to",
    buttonTitle: "Download & email forms",
  },
  {
    title: "Print all the forms & sign",
    subtitle: "Sign on all marked boxes",
  },
  {
    title: "Courier the signed documents at our given address",
  },
];

export const ERROR_MESSAGES = {
  reasonInputError: "Please enter a reason",
  reasonTextTooShort: "Text must be atleast 5 characters long",
};
